/**
 * DynamicPreferencesDemoPage - Pass 3 schema-driven preview
 *
 * Renders <DynamicPreferenceForm /> for any category. Used by admin/QA to
 * validate the canonical schema. Route: /preferences/dynamic/:category
 * Optional query: ?instructor=1 to test instructor-linked merge.
 */
import { useParams, useSearchParams } from "react-router-dom";
import { useState } from "react";
import DynamicPreferenceForm from "../components/DynamicPreferenceForm";

export default function DynamicPreferencesDemoPage() {
  const { category = "makeup" } = useParams();
  const [searchParams] = useSearchParams();
  const instructorLinked = searchParams.get("instructor") === "1";
  const [answers, setAnswers] = useState({});

  return (
    <div className="min-h-screen bg-stone-50" data-testid="dynamic-preferences-demo">
      <div className="max-w-2xl mx-auto px-6 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-light tracking-tight">Dynamic preferences - {category}</h1>
          <p className="text-sm text-stone-500 mt-1">
            Schema-driven render from <code className="text-xs bg-stone-100 px-1.5 py-0.5 rounded">/api/sync/preference-card-schema?category={category}</code>
            {instructorLinked && <span className="ml-2 text-emerald-700">· instructor-linked</span>}
          </p>
        </div>
        <div className="bg-white border border-stone-200 rounded-xl p-6 shadow-sm">
          <DynamicPreferenceForm
            category={category}
            value={answers}
            onChange={setAnswers}
            serviceContext={{ instructor_linked: instructorLinked }}
          />
        </div>
        <details className="mt-6 text-xs text-stone-500">
          <summary className="cursor-pointer hover:text-stone-900">Current answers (debug)</summary>
          <pre className="mt-2 p-3 bg-stone-100 rounded overflow-auto max-h-64">{JSON.stringify(answers, null, 2)}</pre>
        </details>
      </div>
    </div>
  );
}
